import React from 'react';
import Map from '../map/Map'
import MenuPage from '../../pages/MenuPage';

// import './CustomerMap.css'

const CustomerMap = ({branches, history}) => {
    return (
        <MenuPage title={'Customer name'} onBackClick={()=>{history.goBack()}}>
        <Map branches={branches}/>
        </MenuPage>
    )
};

export default CustomerMap;


// WEBPACK FOOTER //
// ./src/components/customerMap/CustomerMap.js